export default __webpack_public_path__ + "static/media/howItWorks1.6853ab2e.png";